import script from "./ModalComp.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalComp.vue?vue&type=script&setup=true&lang=js"

import "./ModalComp.vue?vue&type=style&index=0&id=6eede230&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6eede230"]])

export default __exports__